import React from 'react'
import CSSModules from 'react-css-modules'
import styles from './FieldHeader.scss'

const FieldHeader = ({
	htmlFor,
	title,
	error,
	isRequired,
	isReadOnly,
	body,
	disabled
}) => (
	<div styleName={disabled ? 'header-disabled' : 'header'}>
		<div styleName="title">
			<label htmlFor={htmlFor}>{title}</label>
		</div>
		<div styleName={error ? 'is-required-error' : 'is-required'}>
			{isRequired ? 'required' : ''}
			{isReadOnly ? 'read-only' : ''}
		</div>
		{body ? <div>{body}</div> : ''}
	</div>
)

FieldHeader.propTypes = {
	title: React.PropTypes.string,
	htmlFor: React.PropTypes.string,
	error: React.PropTypes.bool,
	isRequired: React.PropTypes.bool
}

export default CSSModules(FieldHeader, styles)



// WEBPACK FOOTER //
// /opt/build/repo/packages/components/Form/FieldHeader.js